import "core-js/modules/es.function.name.js";
/* eslint-disable react/prop-types */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import MultiDropdownSelect from "../core/input/MultiDropdownSelect";
var ApplicationStageSelectorInput = function ApplicationStageSelectorInput(_ref) {
  var applicationStagesOptions = _ref.applicationStagesOptions,
    className = _ref.className,
    fieldName = _ref.fieldName,
    id = _ref.id,
    multi = _ref.multi,
    name = _ref.name,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    value = _ref.value;
  var handleChange = useCallback(function (obj) {
    if (!onChange) return;
    var nextValue = obj[name];
    onChange({
      target: {
        name: name,
        value: nextValue
      }
    });
  }, [onChange, name]);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    id: id
  }, fieldName ? /*#__PURE__*/React.createElement(Field, {
    name: fieldName,
    component: MultiDropdownSelect,
    placeholder: placeholder,
    type: "select",
    multi: multi,
    clearable: true,
    options: applicationStagesOptions
  }) : /*#__PURE__*/React.createElement(MultiDropdownSelect, {
    clearable: true,
    iden: name,
    multi: multi,
    onChange: handleChange,
    options: applicationStagesOptions,
    placeholder: placeholder,
    inputValue: value
  }));
};
ApplicationStageSelectorInput.propTypes = {
  className: PropTypes.string,
  fieldName: PropTypes.string,
  id: PropTypes.string,
  multi: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string
};
ApplicationStageSelectorInput.defaultProps = {
  multi: false
};
export default ApplicationStageSelectorInput;